import { Injectable } from '@angular/core';
import { Resolve } from '@angular/router';
import { ICmsBlock, NICmsBlock } from '@icms/core/resource/block/icms-block';
import { ICmsBlockResource } from '@icms/core/resource/block/icms-block.resource';
import { NBasketViewCms } from './basket-view-cms.component';
@Injectable({ providedIn: 'root' })
export class BasketViewCmsResolver implements Resolve<void | ICmsBlock<NICmsBlock.IData>> {
    constructor(private iCmsBlockResource: ICmsBlockResource) { }
    resolve(): Promise<void | ICmsBlock<NICmsBlock.IData>> {
        return this.iCmsBlockResource.retrieve({ bareUrl: NBasketViewCms.BLOCK_ID }, undefined);
    }
}
